export default __webpack_public_path__ + "static/media/arrow-right.2fea8f00.svg";